import { FC } from 'react';
import clsx from 'clsx';
import { IUser } from '../../../../types';
import styles from './styles.module.css';
import Loader from '../../../../components/loader';
import Clinician from './clinician';

interface IUsersManageClinicianList {
  show: IUser[] | undefined;
  isLoading: boolean;
  refresh: () => void;
}

const UsersManageClinicianList: FC<IUsersManageClinicianList> = props => {
  const { show, isLoading, refresh } = props;

  return (
    <div className={styles.tableWrapper}>
      {/* header row */}
      <div className={clsx(styles.tableHeader, 'is-hidden-mobile')}>
        <div className={styles.rowLeft}>
          <div className={styles.rowItem}>Name</div>
          <div className={styles.rowItem}>Email</div>
        </div>
        <div className={styles.rowRight}>
          <div className={styles.rowItem}>Type</div>
          <div className={styles.rowMenu}>Actions</div>
        </div>
      </div>

      {/* table */}
      <div className={styles.table}>
        {isLoading && (
          <div className={styles.loader}>
            <Loader loading={isLoading} />
          </div>
        )}

        {show && !show.length && (
          <div className={styles.loader}>
            <span>No clinicians found to manage.</span>
          </div>
        )}

        {show &&
          show.length > 0 &&
          show.map((user, i) => <Clinician key={i} user={user} refresh={refresh} />)}

        {show && show.length > 0 && (
          <div className={styles.loader} style={{ paddingTop: '2rem' }}>
            <span className={styles.textMuted}>
              {`${show.length} result${show.length > 1 ? 's' : ''}`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersManageClinicianList;
